import { animateScroll as scroll } from "react-scroll";

export function formatCPF(value) {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
}
export function formatCNPJ(value) {
  return value
    .replace(/\D+/g, "") // não deixa ser digitado nenhuma letra
    .replace(/(\d{2})(\d)/, "$1.$2") // captura 2 grupos de número o primeiro com 2 digitos e o segundo de com 3 digitos, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de número
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2") // captura 2 grupos de número o primeiro e o segundo com 3 digitos, separados por /
    .replace(/(\d{4})(\d)/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1"); // captura os dois últimos 2 números, com um - antes dos dois números
}

export function formatPhone(value) {
  value = value.replace(/\D/g, "").replace(/(\(|\)|-)/g, "");
  if (value.length === 11) {
    return `${value}`.replace(/(\d{2})(\d{5})(\d{4})/g, "($1)$2-$3");
  }
  return `${value}`.replace(/(\d{2})(\d{4})(\d{4})/g, "($1)$2-$3");
}

export function formatDate(value) {
  const date = value.split("/");
  return `${date[2]}-${date[1]}-${date[0]}`;
}

export function formatDateView(value) {
  const dateTime = value.split("T");
  const date = dateTime[0].split("-");
  return `${date[2]}/${date[1]}/${date[0]}`;
}

export function removeMask(value) {
  return value?.replace(/\D+/g, "");
}

export function getStorageValueToken(key) {
  // getting stored value
  const saved = localStorage.getItem(key);
  if (saved) {
    const initial = JSON.parse(saved);
    return JSON.parse(initial?.authentication) || null;
  } else {
    return null;
  }
}

export function nameMask(value) {
  const regEx = /[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ\s]/;
  return value.split("").map((char) => (regEx.test(char) ? regEx : ""));
}
export function phoneMask(value) {
  const onlyNumber = value.replace(/\D/g, "");
  if (onlyNumber && onlyNumber.length > 10) {
    return [
      "(",
      /\d/,
      /\d/,
      ")",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  }
  return [
    "(",
    /\d/,
    /\d/,
    ")",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
}

export function phoneWithoutDDDMask(value) {
  const onlyNumber = value.replace(/\D/g, "");
  if (onlyNumber && onlyNumber.length > 8) {
    return [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
  }
  return [/\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
}

export function extractPhoneDDD(telefone) {
  const match = telefone?.match(/\((\d{2})\)/);
  return match ? match[1] : null;
}

export function extractPhoneNumber(telefone) {
  const match = telefone?.match(/\)\s?(\d{4,5}-\d{4})/);
  return match ? match[1] : null;
}

export function dddMask(value) {
  const onlyNumber = value.replace(/\D/g, "");
  if (onlyNumber && onlyNumber.length > 10) {
    return [/\d/, /\d/];
  }
  return [/\d/, /\d/];
}

export function cpfMask() {
  return [
    /\d/,
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
  ];
}

export function dateMask() {
  return [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
}

export function phoneWithOutDDDValidation(phone) {
  const excludedPhoneNumbers = [
    "0000-0000",
    "1111-1111",
    "2222-2222",
    "3333-3333",
    "4444-4444",
    "5555-5555",
    "6666-6666",
    "7777-7777",
    "8888-8888",
    "9999-9999",
    "00000-0000",
    "11111-1111",
    "22222-2222",
    "33333-3333",
    "44444-4444",
    "55555-5555",
    "66666-6666",
    "77777-7777",
    "88888-8888",
    "99999-9999",
  ];

  const phonePattern = /^\d{4,5}-\d{4}$/;

  return phonePattern.test(phone) && !excludedPhoneNumbers.includes(phone);
}

export function phoneDDDValidation(phone) {
  // return /^\[0-9]{2}\$/.test(phone);
  return /^\d{2}$/.test(phone);
}

export function phoneValidation(phone) {
  return /^(?:\()[0-9]{2}(?:\))\s?[0-9]{4,5}(?:-)[0-9]{4}$/.test(phone);
}

export function cpfValidation(strCpf) {
  const cpf = removeMask(strCpf);
  if (!/[0-9]{11}/.test(cpf)) return false;
  if (cpf === "00000000000") return false;
  if (cpf === "11111111111") return false;
  if (cpf === "22222222222") return false;
  if (cpf === "33333333333") return false;
  if (cpf === "44444444444") return false;
  if (cpf === "55555555555") return false;
  if (cpf === "66666666666") return false;
  if (cpf === "77777777777") return false;
  if (cpf === "88888888888") return false;
  if (cpf === "99999999999") return false;

  let soma = 0;
  let resto;

  for (let i = 1; i <= 9; i += 1)
    soma += parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
  resto = (soma * 10) % 11;

  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10), 10)) return false;

  soma = 0;
  for (let i = 1; i <= 10; i += 1)
    soma += parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
  resto = (soma * 10) % 11;

  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11), 10)) return false;
  return true;
}

export function scrollTo(numberY) {
  scroll.scrollTo(numberY);
  // window.scrollTo({
  //   top: numberY,
  //   behavior: "smooth",
  // });
}

export function scrollTop() {
  scroll.scrollToTop();
}

export function scrollBottom() {
  scroll.scrollToBottom();
}

export function urlEncode(obj) {
  const values = new URLSearchParams();
  Object.keys(obj).forEach((key) => {
    values.append(`${key}`, `${obj[key]}`);
  });
  return values;
}

// BI
export function pageView(data) {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "Page View",
      label: data,
    });
  }
}

export function sendError(message) {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "sendEvent",
      "event-action": "etapa-erro",
      "event-value": message,
    });
  }
}

export function checkHasNumber(value) {
  const regex = /\d/;
  return regex.test(value);
}

export function checkHasString(value) {
  const regex = /[A-Za-z]+/;
  return regex.test(value);
}

export function checkHasSpecialCharacter(value) {
  const regex = /[!@#$%^&*()_~+`\-=[\]{};':"\\|,.<>/?]/;
  return regex.test(value);
}

export function getBase64(file) {
  return new Promise((resolve) => {
    let baseURL = "";
    // Make new FileReader
    let reader = new FileReader();
    // Convert the file to base64 text
    reader.readAsDataURL(file);
    // on reader load somthing...
    reader.onload = () => {
      // Make a fileInfo Object
      baseURL = reader.result;
      resolve(baseURL);
    };
  });
}

export function spliceIntoChunks(arr, chunkSize) {
  let res = [];
  while (arr?.length > 0) {
    const chunk = arr.splice(0, chunkSize);
    res.push(chunk);
  }
  return res;
}

export function cnpjValidate(cnpj) {
  const b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const c = String(cnpj).replace(/[^\d]/g, "");

  if (c.length !== 14 || /^(\d)\1{13}$/.test(c)) return false;

  let n = 0;
  for (let i = 0; i < 12; i++) {
    n += parseInt(c[i]) * b[i + 1];
  }
  let d1 = n % 11;
  d1 = d1 < 2 ? 0 : 11 - d1;
  if (parseInt(c[12]) !== d1) return false;

  n = 0;
  for (let i = 0; i < 13; i++) {
    n += parseInt(c[i]) * b[i];
  }
  let d2 = n % 11;
  d2 = d2 < 2 ? 0 : 11 - d2;
  if (parseInt(c[13]) !== d2) return false;

  return true;
}
export function zipCodeMask() {
  return [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];
}

export function formatNumberToBRL(value) {
  let userInput = value.replace(/\D/g, "");

  if (userInput === "") {
    return "R$ 0,00";
  } else {
    let userInputAsNumber = parseInt(userInput, 10) / 100;
    let formattedNumber = `R$ ${userInputAsNumber
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+,)/g, "$1.")}`;
    return formattedNumber;
  }
}

export function abbreviateName(fullName) {
  if (!fullName) return "";

  const nameParts = fullName.split(" ");
  const firstName = nameParts[0];
  const middleInitials = nameParts.slice(1, -1).map((name) => name[0] + ".");
  const lastName = nameParts[nameParts.length - 1];

  if (middleInitials.length === 0) {
    return `${firstName} ${lastName[0]}.`;
  }

  let abbreviatedMiddleNames = "";
  if (middleInitials.length > 0) {
    abbreviatedMiddleNames = middleInitials.join(" ");
  }

  const abbreviatedLastName = `${lastName[0]}.`;
  const abbreviated = `${firstName} ${abbreviatedMiddleNames} ${abbreviatedLastName}`;
  return abbreviated;
}
